import { BrandsApiService } from '../../common/services/brands.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,

  state: {
    status: REQUEST_STATUS.LOADING,
    items: [],
    total: 0,
  },

  getters: {
    getAllBrands: state => state.items,
    getTotal: state => state.total,
    getStatus: state => state.status,
    getBrand: state => id => state.items.find(item => item.id === id),
  },

  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_TOTAL(state, data) {
      state.total = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },

  actions: {
    fetchAllBrands({ commit, dispatch }, { options }) {
      commit('FETCH_REQUEST');

      return BrandsApiService.getAll(builder => {
        if (options && options.pagination === false) {
          builder.turnOffPagination();
        }
      })
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('SET_TOTAL', response.getMeta().records);
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
